module.exports = __webpack_public_path__ + "img/walmart.4a081912.png";